<template>
  <div>
    <div v-if="admin">
    <v-col cols="12">
      <v-row class="ma-2 justify-center">
        <h3 class="primary--text">ADMIN - Configurações</h3>
      </v-row>
      <v-row class="justify-center">
      <v-col cols="12" md="10">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Admin - autorizados
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="justify-center align-center">
                <v-btn text color="primary" @click="show_uid_aut = true">
                  <v-icon class="mr-2">mdi-plus</v-icon>
                  novo
                </v-btn>
              </v-row>
              <v-row class="justify-center">
                <v-list dense>
                  <v-list-item-group>
                    <v-list-item v-for="item in autorizados" :key="item.id" class="linha">
                      <v-list-item-content @click="sel_uid_aut(item)">
                        <v-list-item-title>{{ item.uid }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-row>
              <v-row class="justify-center" v-if="show_uid_aut">
                <v-col cols="6">
                  <v-row>
                    <v-text-field
                      class="mx-2"
                      label="UID"
                      v-model="uid_aut"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-row>
                  <v-row>
                    <v-btn small color="warning" rounded @click="cancel_uid_aut()">cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn small color="error" rounded @click="delete_uid_aut()">excluir</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn small color="primary" rounded @click="salvarAut()">{{fazer}}</v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        
        <PrecosPorCm/>
        <imagens/>
        <UsuariosDesc/>
        <GerarTabela/>
        <Backup />
       
      </v-col>
    </v-row>
    </v-col>
  </div>
  <div v-else>
    <v-row style="height:80vh" class="justify-center align-center">
      <v-progress-circular
        :size="60"
        :width="8"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
  <v-snackbar v-model="alert" multi-line color="accent" :timeout="2000">
    {{ msg }}
    <template v-slot:action="{ attrs }">
      <v-btn color="white" text v-bind="attrs" @click="alert = false">
        X
      </v-btn>
    </template>
  </v-snackbar>
  </div>
</template>

<script>
import Imagens from '../components/Imagens.vue'
import PrecosPorCm from '../components/PrecosPorCm.vue'
import UsuariosDesc from '../components/TableUsers.vue'
import GerarTabela from '../components/GerarTabela.vue'
// import UsuariosDesc from '../components/UsuariosDesc.vue'
import Backup from '../components/Backup.vue'

export default {
  name: "config-admin",
  components: {
    Imagens,
    PrecosPorCm,
    UsuariosDesc,
    GerarTabela,
    Backup
  },
  mounted() {
    setTimeout(() => {
      if (this.user) {
        for (let i = 0; i < this.autorizados.length; i++) {
          const el = this.autorizados[i];
          if (el.uid === this.user.uid) {
            this.admin = true
          }
        }
        if (!this.admin) {
          this.$router.push('/')
        }
      }
        }, 1000);
  },
  computed: {
    autorizados() {
      return this.$store.getters.autorizados
    },
    user() {
      return this.$store.getters.user
    }
  },
  data() {
    return {
      alert: false,
      msg: "",
      admin: false,
      uid_aut: "",
      uid_aut_sel: {},
      fazer: "incluir",
      show_uid_aut: false,
      rules: {
          required: value => !!value || 'Obrigatório',
          uid: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'E-mail inválido.'
          },
        }
    }
  },
  methods: {
    salvarAut() {
      if(!this.uid_aut) {
        return
      }
      const obj = {
        uid: this.uid_aut
      }
      if(this.fazer === "incluir"){
        this.insert_uid_aut(obj)
      } else {
        this.update_uid_aut(obj)
      }
    },
    sel_uid_aut(obj) {
      this.fazer = "alterar"
      this.uid_aut_sel = obj
      this.uid_aut = obj.uid
      this.show_uid_aut = true
    },
    insert_uid_aut(obj){
      this.$store.dispatch("saveAutorizado", obj)
      this.$store.dispatch("loadAutorizados")
      this.cancel_uid_aut()
      this.showAlert("Salvo com sucesso!")
    },
    cancel_uid_aut() {
      this.fazer = "incluir"
      this.uid_aut_sel = {}
      this.uid_aut = ""
      this.show_uid_aut = false
    },
    update_uid_aut(obj){
      obj.id = this.uid_aut_sel.id
      this.$store.dispatch("updateAutorizado", obj)
      this.$store.dispatch("loadAutorizados")
      this.cancel_uid_aut()
      this.showAlert("Alterado com sucesso!")
    },
    delete_uid_aut(){
      const id = this.uid_aut_sel.id
      this.$store.dispatch("deleteAutorizado", id)
      this.$store.dispatch("loadAutorizados")
      this.cancel_uid_aut()
      this.showAlert("Excluído com sucesso!")
    },
    showAlert(msg) {
        this.msg = msg;
        this.alert = true;
      },
  },
};
</script>

<style scoped>
.linha:nth-child(even) {
  background-color: #f2f2f2;
}
.linha:nth-child(odd) {
  background-color: #ffffff;
}
</style>